export default __webpack_public_path__ + "a99d8db918ca0d83907a66773ecd8d0f.woff";